module.exports = __webpack_public_path__ + "fbfbf698296891092937591f6e5a7679.woff";